import React, { useEffect, useState, useRef } from "react";
import LcTooltip from "../../Generic/LcTooltip";
import ContentEditable from "react-contenteditable";
import Lightning from "../../../assets/images/Lightning.svg";
import "./index.css";
import SvgIcon from "../../Generic/SvgIcon";
import HHCommentAI from "../../Generic/HHCommentAI";
import { useSelector } from "react-redux";
import { RootState } from "../../../store";
import { UserState } from "../../../store/reducers/userReducer";
import LcDropDown from "../../Generic/LcDropDown";
import { BsArrows, BsArrowsAngleContract, BsType } from "react-icons/bs";
import { AiOutlineSound } from "react-icons/ai";
import { PiMagicWand } from "react-icons/pi";
import { Menu, MenuItem, SubMenu } from "@szhsin/react-menu";
import '@szhsin/react-menu/dist/index.css';
import TextTools from "../../../services/TextTools/TextTools";

interface Props {
    label?: string;
    height?: string | number;
    width?: string | number;
    placeholder?: string;
    handleChange: Function;
    error?: any;
    help?: any;
    disabled?: boolean;
    required?: boolean;
    handleFiles?: Function;
    value?: string;
    suggestion?: boolean;
    solicitation?: number;
    suggestionStyle?: any;
    suggestionStyleItem?: any;
    id?: string;
    modalAI?: boolean;
    auxProps?: { [key: string]: any }; // Add this line to include auxProps
}

const HHDescriptionTextBox: React.FC<Props> = (props) => {
    const user = useSelector<RootState, UserState>(state => state.user);
    const [text, setText] = useState<string>(props.value || "");
    const [focused, setFocused] = useState<boolean>(false);
    const [sugestaoExp, setSugestaoExp] = useState<boolean>(false);
    const [AiInstruction, setAiInstruction] = useState<number>(0);
    const editorRef = useRef(null);
    const textTools = new TextTools();

    const cleanHtml = (html) => {
        const div = document.createElement("div");
        div.innerHTML = html;
        return div.textContent || div.innerText || "";
    };

    useEffect(() => {
        const editor = editorRef.current;
        if (editor) {
            if (props.value) {
                setText(props.value);
            }
            else {
                props.placeholder && setText(props.placeholder);
            }
        }
    }, [props.value]);

    const getBorder = () => {
        if (props.error && !props.error.valid) {
            return "";
        }
        else if (props.disabled && props.disabled === true) {
            return "";
        }
        else if (props.required && props.required === true) {
            return "3px solid #FFB800";
        }
    }

    const pasteImage = async (event: any) => {
        if (props.handleFiles) {
            if (event.type === "paste") {
                const itemFile = (event.originalEvent || event).clipboardData.getData("text/html");
                const textFile = (event.originalEvent || event).clipboardData.getData("text/plain");
                const item = event.clipboardData?.items[0] || event.clipboardData?.files[0];
                const parser = new DOMParser();
                const doc = parser.parseFromString(itemFile, "text/html");
                const image = doc.querySelector("img");

                if (image) {
                    const respose = await fetch(image.src);
                    const blob = await respose.blob();
                    const fileBlob = new File([blob], "Anexo.jpeg", { type: blob.type })
                    const reader = new FileReader();

                    fileBlob && reader.readAsDataURL(fileBlob);
                    props.handleChange(textFile);
                    props.handleFiles([fileBlob]);
                }
                else if (item && item.type.indexOf("image") === 0) {
                    const blob = item.getAsFile();
                    const reader = new FileReader();

                    blob && reader.readAsDataURL(blob);
                    props.handleFiles([blob]);
                }
            }
            else {
                const item = event.dataTransfer?.items[0] || event.dataTransfer?.files[0];
                const blob = item.getAsFile();
                const reader = new FileReader();

                blob && reader.readAsDataURL(blob);
                props.handleFiles([blob]);
            }
        }
    }

    const handleChange = (e: any) => {
        if (!props.disabled) {
            const inputType = e.nativeEvent.inputType;
            let texto = e.target.value;

            texto = textTools.removeHtmlTags(texto);

            if ((inputType === "insertFromPaste") && e.target.value.includes("<img ")) {
                return;
            }

            setText(texto);
            props.handleChange(texto);
        }
    };

    const handleKeyPress = (e: any) => {
        if (props.disabled) {
            e.preventDefault();
        }

        if (!props.disabled) {
            if (props.placeholder && text === props.placeholder) {
                setText("");
            }

            setFocused(true);
        }
    };

    const handleFocus = () => {
        if (!props.disabled) {
            if (props.placeholder && text === props.placeholder) {
                setText("");
            }

            setFocused(true);
        }
    };

    const handleBlur = () => {
        setFocused(false);
    };

    const disabledPasteImage = async (event: any) => {
        const items = (event.clipboardData || event.originalEvent.clipboardData).items;

        for (let i = 0; i < items.length; i++) {
            if (items[i].type.indexOf("image") !== -1) {
                event.preventDefault();
                return;
            }
        }
    }

    const handleCleanText = () => {
        return text
            .replace(/&nbsp;/g, "")             // Substitua todas as ocorrências de '&nbsp;' por uma string vazia
            .replace(/<br>/g, "")               // Substitua todas as ocorrências de '<br>' por uma string vazia
            .replace(/<div>(\s*)<\/div>/g, "")  // Substitua todas as ocorrências de '<div> </div>' por uma string vazia
            .trimEnd();
    }

    const AIOpts = [
        {
            icon: <PiMagicWand />,
            text: 'Elaborar',
            value: 1
        },
        {
            icon: <BsArrowsAngleContract style={{ transform: ' rotate(45deg)' }} />,
            text: 'Reduzir',
            value: 2
        },
        {
            icon: <BsArrows />,
            text: 'Expandir',
            value: 3
        },
        {
            icon: <BsType />,
            text: 'Corrigir ortografia',
            value: 5
        },
    ]

    const changeToneOpts = {
        icon: <AiOutlineSound />,
        text: 'Mudar tom',
        subMenu: [
            {
                text: 'Comunicativo',
                value: 6
            },
            {
                text: 'Bem-humorado',
                value: 7
            },
            {
                text: 'Entusiasmado',
                value: 8
            },
            {
                text: 'Informativo',
                value: 9
            },
            {
                text: 'Profissional',
                value: 10
            },
            {
                text: 'Inteligente',
                value: 11
            },
            {
                text: 'Confiável',
                value: 12
            },
        ],
        value: 4
    }

    return (
        <>
            {
                props.label &&
                <div className={"input-4 label2"}> {props.label} </div>
            }

            <div style={{ marginTop: (props.suggestion) ? "0" : "0", width: "100%" }}>
                {
                    props.suggestion &&
                    <div style={props.suggestionStyle}>
                        <div
                            style={props.suggestionStyleItem}
                            onClick={(e) => {
                                if ((handleCleanText()).length > 0 && props.solicitation) {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    setSugestaoExp(!sugestaoExp);
                                }
                            }}
                        >
                            {
                                (window.screen.width > 600)
                                    ? <LcTooltip
                                        content={((handleCleanText()).length === 0 || text === props.placeholder) ? "Digite algo para habilitar o texto personalizado" : "Assistente de AI"}
                                        trigger={"hover"}
                                        top
                                    >
                                        {
                                            !props.solicitation
                                                ? <Menu
                                                    className={'AiMenu'}
                                                    menuButton={
                                                        <button
                                                            type='button'
                                                            className="IconSvg"
                                                            style={{ border: 'none', background: 'inherit' }}
                                                            disabled={(handleCleanText()).length === 0 || text === props.placeholder}
                                                            onClick={() => { if (sugestaoExp) setSugestaoExp(false) }}>
                                                            <SvgIcon
                                                                icon={Lightning}
                                                                width={(window.screen.width < 600) ? 20 : 25}
                                                                height={(window.screen.width < 600) ? 20 : 25}
                                                                disabled={(handleCleanText()).length === 0 || handleCleanText() === props.placeholder}
                                                                active={sugestaoExp}
                                                            />
                                                        </button>
                                                    }>
                                                    {
                                                        AIOpts.map(Ai => {
                                                            return (
                                                                <MenuItem
                                                                    className={'AiMenuItem'}
                                                                    onClick={(e) => {
                                                                        if (handleCleanText().length > 0) {
                                                                            setAiInstruction(Ai.value);
                                                                            setSugestaoExp(!sugestaoExp);
                                                                        }
                                                                    }}>
                                                                    <div className="row item">
                                                                        {Ai.icon}
                                                                        <span style={{ fontSize: '12px' }}>{Ai.text}</span>
                                                                    </div>
                                                                </MenuItem>
                                                            )
                                                        })
                                                    }
                                                    <SubMenu 
                                                        className={'aiSubMenu'}
                                                        label={
                                                            <div className="row item">
                                                                {changeToneOpts.icon}
                                                                <span style={{ fontSize: '12px' }}>{changeToneOpts.text}</span>
                                                            </div>
                                                        } >
                                                        {
                                                            changeToneOpts.subMenu.map(sub => {
                                                                return (
                                                                    <MenuItem
                                                                        className={'AiMenuItem'}
                                                                        onClick={(e) => {
                                                                            if ((handleCleanText()).length > 0) {
                                                                                setAiInstruction(sub.value);
                                                                                setSugestaoExp(!sugestaoExp);
                                                                            }
                                                                        }}>
                                                                        <div className="row item">
                                                                            <span style={{ fontSize: '12px' }}>{sub.text}</span>
                                                                        </div>
                                                                    </MenuItem>
                                                                )
                                                            })
                                                        }
                                                    </SubMenu>
                                                </Menu>
                                                : <SvgIcon
                                                    icon={Lightning}
                                                    height={25}
                                                    width={25}
                                                    disabled={(handleCleanText()).length === 0 || handleCleanText() === props.placeholder}
                                                    active={sugestaoExp}
                                                />
                                        }
                                    </LcTooltip>
                                    : <>
                                        {
                                            !props.solicitation
                                                ? <Menu
                                                    className={'AiMenu'}
                                                    menuButton={
                                                        <button
                                                            type='button'
                                                            className="IconSvg"
                                                            style={{ border: 'none', background: 'inherit' }}
                                                            disabled={(handleCleanText()).length === 0 || text === props.placeholder}
                                                            onClick={() => { if (sugestaoExp) setSugestaoExp(false) }}>
                                                            <SvgIcon
                                                                icon={Lightning}
                                                                width={(window.screen.width < 600) ? 20 : 25}
                                                                height={(window.screen.width < 600) ? 20 : 25}
                                                                disabled={(handleCleanText()).length === 0 || handleCleanText() === props.placeholder}
                                                                active={sugestaoExp}
                                                            />
                                                        </button>
                                                    }>
                                                    {
                                                        AIOpts.map(Ai => {
                                                            return (
                                                                <MenuItem
                                                                    className={'AiMenuItem'}
                                                                    onClick={(e) => {
                                                                        if ((handleCleanText()).length > 0) {
                                                                            setAiInstruction(Ai.value);
                                                                            setSugestaoExp(!sugestaoExp);
                                                                        }
                                                                    }}>
                                                                    <div className="row item">
                                                                        {Ai.icon}
                                                                        <span style={{ fontSize: '12px' }}>{Ai.text}</span>
                                                                    </div>
                                                                </MenuItem>
                                                            )
                                                        })
                                                    }
                                                    <SubMenu
                                                        className={'aiSubMenu'}
                                                        align={'start'}
                                                        arrow={false}
                                                        label={
                                                            <div className="row item">
                                                                {changeToneOpts.icon}
                                                                <span style={{ fontSize: '12px' }}>{changeToneOpts.text}</span>
                                                            </div>
                                                        } >
                                                        {
                                                            changeToneOpts.subMenu.map(sub => {
                                                                return (
                                                                    <MenuItem
                                                                        className={'AiMenuItem'}
                                                                        onClick={(e) => {
                                                                            if ((handleCleanText()).length > 0) {
                                                                                setAiInstruction(sub.value);
                                                                                setSugestaoExp(!sugestaoExp);
                                                                            }
                                                                        }}>
                                                                        <div className="row item">
                                                                            <span style={{ fontSize: '12px' }}>{sub.text}</span>
                                                                        </div>
                                                                    </MenuItem>
                                                                )
                                                            })
                                                        }
                                                    </SubMenu>
                                                </Menu>
                                                : <SvgIcon
                                                    icon={Lightning}
                                                    height={25}
                                                    width={25}
                                                    disabled={(handleCleanText()).length === 0 || handleCleanText() === props.placeholder}
                                                    active={sugestaoExp}
                                                />
                                        }
                                    </>
                            }
                        </div>
                    </div>
                }
                <LcTooltip
                    content={props.error ? props.help : ""}
                    position={"left"}
                    trigger={(props.error && !props.error.valid) ? "hover" : "none"}
                    width={"100%"}
                    maxWidth={"100%"}
                >
                    <div className={`divOrderRichTextBoxDecriptionNew ${(props.disabled) ? "disabled" : ""}`} style={{ marginTop: '-30px' }}>
                        <div
                            className={`textBoxEditorDecriptionNew ${(props.error && !props.error.valid) ? " classErrorDecriptionNew" : ""}`}
                            style={{
                                borderLeft: getBorder(),
                                backgroundColor: (props.disabled && props.disabled === true) ? "#EBEBEB" : "white",
                                color: (props.disabled && props.disabled === true) ? "darkgray" : "black",
                                marginBottom: sugestaoExp ? '10px' : ''
                            }}
                            onPaste={pasteImage}
                        >
                            <ContentEditable
                                html={text}
                                ref={editorRef}
                                onChange={handleChange}
                                tagName={"div"}
                                className={`editor-content ${sugestaoExp ? "closeWork" : ""}`}
                                onFocus={handleFocus}
                                onBlur={handleBlur}
                                onPaste={disabledPasteImage}
                                contentEditable={!focused || !props.disabled}
                                onKeyDown={handleKeyPress}
                                style={{
                                    minHeight: (props.height) ? props.height : "100%",
                                    padding: "10px",
                                    color: (text === props.placeholder || props.disabled) ? "#bababa" : "#2b304f",
                                    width: (props.suggestion) ? props.solicitation ? '96%' : "92%" : "100%",
                                    letterSpacing: 'normal',
                                    maxHeight: '170px',
                                    display: (props.id === 'solicitationDetails') ? 'flex' : '',
                                    // alignItems: (props.id === 'solicitationDetails') ? 'column' : ''
                                    flexDirection: 'column'
                                }}
                                spellCheck={false}
                                disabled={props.disabled}
                                id={props.id}
                            />
                        </div>
                        <HHCommentAI
                            modal={(!props.solicitation && (window.screen.width > 600))}
                            withOriginalText={!props.solicitation && (window.screen.width > 600)}
                            title={!props.solicitation ? "Assistente de AI" : ''}
                            originalText={text}
                            visible={sugestaoExp}
                            user={user}
                            instructionType={AiInstruction}
                            solicitation={props.solicitation}
                            handleVisible={(value) => setSugestaoExp(value)}
                            setText={(e) => handleChange({ target: { value: e }, nativeEvent: { inputType: "text" } })}
                            conclusion={true}
                            style={{
                                right: "0px",
                                left: "280px",
                                bottom: "6vh",
                                transform: "translateY(-50%)",
                                marginTop: '10px'
                            }}
                            auxProps={props.auxProps}
                        />
                    </div>
                </LcTooltip>
            </div>
        </>
    );
};

export default HHDescriptionTextBox;